import { useCallback, useEffect } from 'react';
import CheckIcon from 'components/icons/check';
import TrashIcon from 'components/icons/trash';
import useDictate from 'hooks/useDictate';
import LiveSpectrogram from './liveSpectrogram';
import {
    Container,
    InputContainer,
    ActionsContainer,
    ActionButton,
} from '../styled';

interface DictateFormProps {
    className?: string;
    onAccept: (audioBlob: Blob | null) => Promise<void> | void;
    onCancel: () => void;
}

const DictateForm = ({
    className,
    onAccept = () => {},
    onCancel = () => {},
}: DictateFormProps) => {
    const {
        audioBlob,
        stream,
        startRecording,
        stopRecording,
        cancelRecording,
    } = useDictate({
        onAutoAccept: onAccept,
    });

    useEffect(() => {
        startRecording();
    }, [startRecording]);

    const handleAccept = useCallback(async (blob: Blob | null) => {
        stopRecording();
        onAccept(blob);
    }, [stopRecording, onAccept]);

    const handleCancel = useCallback(() => {
        cancelRecording();
        onCancel();
    }, [cancelRecording, onCancel]);

    return (
        <Container className={className}>
            <InputContainer>
                <LiveSpectrogram stream={stream} />
                <ActionsContainer>
                    <ActionButton
                        tooltip="Accept"
                        icon={<CheckIcon />}
                        onClick={() => handleAccept(audioBlob)}
                    />
                    <ActionButton
                        tooltip="Cancel"
                        icon={<TrashIcon />}
                        onClick={handleCancel}
                    />
                </ActionsContainer>
            </InputContainer>
        </Container>
    );
};

export default DictateForm;
